import { render, staticRenderFns } from "./expand-column.vue?vue&type=template&id=40da6bb6&scoped=true"
import script from "./expand-column.vue?vue&type=script&lang=js"
export * from "./expand-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40da6bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40da6bb6')) {
      api.createRecord('40da6bb6', component.options)
    } else {
      api.reload('40da6bb6', component.options)
    }
    module.hot.accept("./expand-column.vue?vue&type=template&id=40da6bb6&scoped=true", function () {
      api.rerender('40da6bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/reports/outbound-texts/expand-column.vue"
export default component.exports